"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.IconRoot = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../styles");
const IconRoot = exports.IconRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  fontSize: '3rem',
  width: '26px',
  height: '26px',
  display: 'flex',
  alignItems: 'center'
}));
const Root = exports.Root = (0, _mui.styled)(_styles.MobileOfficeRoot)(({
  theme
}) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
  gap: theme.spacing(3),
  cursor: 'pointer',
  padding: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));